import { LayoutEditorShell } from '../../../lib/form-layout/LayoutEditorShell';
import {
  OBLIGATION_FORM_FIELDS,
  OBLIGATION_FORM_FIELD_NAMES,
  OBLIGATION_DEFAULT_LAYOUT,
  type ObligationFormContext,
} from '../../../lib/form-layout/obligation-fields';
import {
  useAdminActiveObligationLayout,
  useUpdateObligationFormLayout,
} from '../../../queries/obligation-form-layout';
import type { ObligationInputSchema } from '../../../lib/schemas';

/**
 * Thin wrapper around LayoutEditorShell that wires the obligation-form's
 * registry / queries / preview context. Mechanical clone of
 * WellFormLayoutEditor.tsx / TractFormLayoutEditor.tsx — obligations have no
 * lookup-backed selects or reviewer, so the preview context is empty (same
 * shape as TractFormContext).
 */
export function ObligationFormLayoutEditor() {
  const previewDefaults: ObligationInputSchema = {
    name: '',

    applies_to_lease: false,
    applies_to_contract: false,
    applies_to_well: false,

    value_type: 'none',

    attention: null,
    address_1: null,
    address_2: null,
    city: null,
    state: null,
    zip: null,
    phone: null,
    fax: null,
    email: null,

    remarks: null,
  };

  const previewContext: ObligationFormContext = {};

  return (
    <LayoutEditorShell
      title="Obligation form layout"
      breadcrumbLabel="Obligation form layout"
      registry={OBLIGATION_FORM_FIELDS}
      allNames={OBLIGATION_FORM_FIELD_NAMES}
      defaultLayout={OBLIGATION_DEFAULT_LAYOUT}
      useActive={useAdminActiveObligationLayout}
      useUpdate={useUpdateObligationFormLayout}
      previewDefaults={previewDefaults}
      previewContext={previewContext}
    />
  );
}
